module.exports = __webpack_public_path__ + "img/MB_more.e73d569b.png";